// - - - - - - - - - -
// #293 — turn the JobsDetailModal Geocode row (`google_lat`/`google_lon`) into a
// platform-aware Maps link. ~70–80% of Scheduler users are on Mac, so Mac users
// get Apple Maps; everyone else gets Google Maps.
//
// Pure + testable (no inline `navigator` sniffing in the component). Reuses the
// EXACT same `getJobCoords`/`formatJobCoordsLabel` the #205 recommender gate uses
// so the "is this geocoded?" decision can't drift from what the row displays.
// - - - - - - - - - -

import { getJobCoords, formatJobCoordsLabel } from "./installerStopDistance";

// True when the user is on a desktop Mac. `navigator.platform` reports "MacIntel"
// on desktop Mac (and iPadOS 13+, which is fine — Apple Maps works there too);
// iPhone reports "iPhone" → non-Mac → Google. Mis-detection degrades gracefully
// (both URL forms open on either platform), so a loose check is safe.
export function isMacUser(nav) {
  const platform = String(nav?.platform || "");
  const ua = String(nav?.userAgent || "");
  return /Mac/i.test(platform) || /Macintosh/i.test(ua);
}

// Build the maps deep-link for a coordinate. Mac → Apple Maps; else → Google Maps.
export function buildMapsUrl({ lat, lon, label, isMac }) {
  if (isMac) {
    const q = label ? `&q=${encodeURIComponent(label)}` : "";
    return `https://maps.apple.com/?ll=${lat},${lon}${q}`;
  }
  return `https://www.google.com/maps/search/?api=1&query=${lat},${lon}`;
}

// Convenience combiner for the component: returns the Maps href for a geocoded
// job doc, or `null` when the job isn't geocoded (so the caller renders plain
// text — no broken `query=0,0` link). `nav` = the browser `navigator`.
export function jobMapsHref(doc, nav) {
  const coords = getJobCoords(doc);
  if (!coords) return null;
  return buildMapsUrl({
    lat: coords.lat,
    lon: coords.lon,
    label: formatJobCoordsLabel(doc),
    isMac: isMacUser(nav),
  });
}
